<template>
	<vue-final-modal v-slot="{ params, close }" v-bind="$attrs">
		<div class="modalWrapper questDialog" style="opacity: 1; align-items: center; justify-content: center; display: flex; width: 100%; height: 100%;">
			<div ng-controller="questDialogCtrl" clickable="nextLine()" class="questDialogBG unselectable clickable">
				<div class="dialogActor position0 show" ng-class="{show: dialogStarted}">
					<img src="//iwstatic.g.bsrv.su/img/x.gif" class="actor_general_3_illustration" data-cmp-info="10">
					<img src="//iwstatic.g.bsrv.su/img/x.gif" class="emotion general_3 actor_general_3_emotion__illustration" data-cmp-info="10">
					<div class="tooltip textBubble position0 after actor_general_3 show typeinput" ng-class="{show: currentActor == 0}">
						<div class="tooltipContent ownText">
							<div ng-if="currentType != 'MC' || currentActor != 0">
								<div class="spokenText">Ты хочешь избавить нас от разбойников? Очень храбро - какое имя я могу потом высечь на твоем надгробии?</div>
								<div class="tutorial_gravestone_illustration" ng-if="currentType=='input'">
									<div class="name">{{username}}</div>
								</div>
								<form @submit.prevent="onModalClose(close)" ng-submit="submitForm()" ng-if="currentType=='input'" class="ng-pristine ng-valid ng-valid-maxlength">
									<div class="horizontalLine"></div>
									<input type="text" id="dialogInputField" autocomplete="off" v-model="username" maxlength="15" class="ng-pristine ng-valid ng-valid-maxlength ng-touched" required />
									<div class="buttonWrapper">
										<button type="submit" class="clickable">
											<div class="content">
												<span ng-transclude="" class="innerText"><span translate=""><span>Ок</span></span></span>
												<!-- ngIf: price > 0 || forceGoldUsage -->
												<!-- ngIf: price == -1 && !forceGoldUsage -->
												<div class="animationOverlay"></div>
												<i class="checkmark action_check_small_flat_white"></i>
												<i class="checkmark action_check_small_flat_black"></i>
												<i class="checkmark action_check_small_flat_red"></i>
											</div>
										</button>
									</div>
								</form>
							</div>
							<!-- ngIf: currentType == 'MC' && currentActor == 0 -->
						</div>
					</div>
				</div>
				<div class="dialogActor position1 questGiverPortrait questGiver8" ng-class="{show: currentActor == 1}">
					<img src="//iwstatic.g.bsrv.su/img/x.gif" class="actor_robber_illustration" data-cmp-info="10">
					<div class="tooltip textBubble position1 before actor_robber" ng-class="{show: currentActor == 1}">
						<div class="tooltipContent ownText">
							<div ng-if="currentType != 'MC'  || currentActor != 1">
								
							</div>
							<!-- ngIf: currentType == 'MC' && currentActor == 1 -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</vue-final-modal>
</template>

<style lang="scss">

</style>

<script>
import lib from '@/lib';

export default {
	mixins: lib.mixins,
	props: {
		closeable: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		cancelHover: false,
		
		username: '',
	}),
	computed: {},
	methods: {
		onModalOpen(){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_1.ogg');
				audio.play();
			}
		},
		onModalClose(close){
			if(this.gameModel.soundOn){
				var audio = new Audio('//iwstatic.g.bsrv.su/audio/sounds/IWUIS_2.ogg');
				audio.play();
			}
			if(close) close();
		},
	},
	mounted(){
		this.onModalOpen();
	},
	beforeDestroy(){
		this.onModalClose();
	},
	components: {},
}
</script>